// TODO: Fix all eslint warnings

import Vimeo from "@vimeo/player";

import { IVideoPlayerProvider } from "./interfaces/video-player-provider";
import { scriptLoaderService } from "./script-loader.component";

export class VimeoProvider implements IVideoPlayerProvider {
    public createPlayer(frameId: string): Promise<unknown> {
        return scriptLoaderService.loadScript("https://player.vimeo.com/api/player.js")
            .then(() => {
                // eslint-disable-next-line
                const vimeoPlayer = new (<any>window).Vimeo.Player(frameId) as Vimeo;

                return Promise.resolve({
                    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                    play: function () {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                        void vimeoPlayer.play();
                    },
                    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                    pause: function () {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                        void vimeoPlayer.pause();
                    }
                });
            });
    }

    public getPreviewImage(id: string): Promise<unknown> {
        return new Promise((resolve, reject) => {
            void $.get(`https://vimeo.com/api/v2/video/${id}.json`, (data) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (data.length > 0) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const preview = data[0].thumbnail_large || "";
                    resolve(preview);
                } else {
                    reject();
                }
            }).fail((error) => {
                reject(error);
            });
        });
    }

    public getEmbedUrl(videoId: string, allowCookies: boolean, autoplay: boolean): string {
        const autoplayValue = Number(autoplay);

        if (allowCookies === true) {
            return `https://player.vimeo.com/video/${videoId}?api=1&autoplay=${autoplayValue}&muted=1&loop=1`;
        } else {
            return `https://player.vimeo.com/video/${videoId}?api=1&autoplay=${autoplayValue}&muted=1&loop=1&dnt=1`;
        }
    }
}

export const vimeoProvider = new VimeoProvider();
